<template>
    <card :title="title">
        <div class="row">
            <div class="col-12">
                <div class="btn-group">
                    <a v-if="create_route" :href="create_route" class="btn btn-lg btn-primary mb-4">
                        <i class="fas fa-plus"></i>
                    </a>
                    <div v-if="additional_data" v-html="additional_data"></div>
                </div>
            </div>
            <div class="col-12">
                <table :id="tableid" ref="dataTable"
                       class="table table-striped table-dark table-hover table-responsive-sm no-footer dataTable">
                    <thead>
                    <tr>
                        <th scope="row" v-for="attribute in attributes">{{ attribute.name }}</th>
                    </tr>
                    </thead>
                    <thead>
                    <tr>
                        <th scope="row" v-for="attribute in attributes">
                            <input v-if="attribute.searchable"
                                   type="text" class="form-control input-sm text-center"
                                   data-action="filter"
                                   :placeholder="`✏️ ${attribute.name}`"/>
                            <input v-else
                                   type="text" class="form-control input-sm"
                                   disabled/>
                        </th>
                    </tr>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>
        </div>
    </card>
</template>

<script>
import datables from 'datatables.net-bs4'

require("datatables.net-bs4/css/dataTables.bootstrap4.min.css");


export default {
    name: "DatatableList",
    props: {
        title: {
            type: String,
            required: true,
        },
        attributes: {
            type: Array,
            required: true,
        },
        list_route: {
            type: String,
            required: true,
        },
        status: {
            required: false,
        },
        create_route: {
            type: String,
            required: false,
        },
        additional_data: {
            type: String,
            required: false,
        },
        orderField: {
            type: Number,
            required: false,
            default: 0
        },
    },
    //props: ['title', 'attributes', 'list_route', 'status', 'create_route', 'additional_data', 'order_field'],
    beforeMount() {
        this.attributes.forEach(function (attribute, index) {
            this.columndefs.push({
                data: attribute.value,
                name: attribute.value,
                orderable: true,
                searchable: attribute.searchable,
                type: (this.getColumnDefs(attribute)).type,
                targets: index,
                render: (this.getColumnDefs(attribute)).render,
            });

        }, this);
    },
    mounted() {
        this.getData();
    },
    data() {
        return {
            columndefs: [],
            tableid: `list_table_` + Math.floor(Math.random() * 100),
            filterHead: "",
        }
    },
    methods: {
        getData() {
            $(`#${this.tableid}`).DataTable({
                // set the initial value
                ordering: true,
                //orderCellsTop: true,
                select: true,
                info: true,
                autoWidth: false,

                pageLength: 50,
                stateSave: true,
                order: [[this.orderField, "desc"]],
                fixedColumns: true,

                bPaginate: true,
                searching: true,
                processing: true,
                serverSide: true,
                ajax: this.list_route,
                columnDefs: this.columndefs,
                language: {
                    url: '//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json'
                },
                initComplete: function (settings, json) {
                    //$('#tabla_filter').hide();

                    const api = this.api()
                    $("input[data-action=filter]").on('keyup change', function (e) {
                        e.stopPropagation()

                        $(this).attr('title', $(this).val());
                        let regexr = '({search})'; //$(this).parents('th').find('select').val();

                        api.column($(this).parent().index() + ':visible')
                            //.search(this.value)
                            .search(this.value !== ''
                                    ? regexr.replace('{search}', '(((' + this.value + ')))')
                                    : '',
                                this.value !== '',
                                this.value === ''
                            )
                            .draw()

                        const cursorPosition = this.selectionStart;
                        $(this)
                            .focus()[0]
                            .setSelectionRange(cursorPosition, cursorPosition);
                    });
                }
            });
        },

        getColumnDefs(attribute) {
            let type;
            let render;

            if (attribute.value === 'actions') {
                type = 'html';
                render = function (data, type, row, meta) {
                    if (Array.isArray(data)) {
                        let html = `<div class="btn-group-lg">`;
                        data.forEach(function (button) {
                            switch (button[0]) {
                                case "edit_button":
                                    html += `<a href="${button[1]}" class="button btn-group">
                                                      <i class="fas fa-edit"></i></a>`;
                                    break;
                                case "destroy_button":
                                    let formId = `resource_${row.id}`;
                                    let element = row.name ? row.name : 'recurso';
                                    html += `
                                            <a class="button btn-group" role="button"

                                               onclick="return confirm('¿Quiere eliminar ${element}?') ? document.getElementById('${formId}').submit() : false;">
                                                <i class="fas fa-trash text-danger"></i>
                                            </a>`;

                                    html += `<form id="${formId}" action="${button[1]}" method="post">
                                                    <input type="hidden" name="_method" value="DELETE">
                                                    <input type="hidden" name="_token" value="${window.data.csrfToken}">
                                                 </form>`;
                                    break;
                                case "multimedia_button":
                                    html += `<a href="${button[1]}" class="button btn-group">
                                                      <i class="fas fa-photo-video text-success"></i></a>`;
                                    break;
                                case "pdf_button":
                                    html += `<a href="${button[1]}" class="button btn-group">
                                                      <i class="fas fa-file-pdf text-success"></i></a>`;
                                    break;
                                case "custom_button":
                                    html += `<a href="${button[1]}" class="button btn-group">
                                                      <i class="${button[2]}"></i></a>`;
                                    break;
                                default:
                                    console.error(button);
                            }

                        });
                        html += `</div>`;
                        return html;
                    } else {
                        return `<a href="${data}" class="button btn-group-sm"><i class="fas fa-edit"></i></a>`;
                    }
                };
            } else {
                if (attribute.type === 'image') {
                    type = 'html';
                    render = function (data, type, row, meta) {
                        return `<img src="${data}" alt="${data}" class="datatable-list-image">`;
                    };
                } else if (attribute.type === 'url') {
                    type = 'html';
                    render = function (data, type, row, meta) {
                        data = JSON.parse(data.replace(/&quot;/g, '"'))
                        return `<a href="${data.href}" target="_blank" class="">${data.name}</a>`;
                    };
                } else {
                    type = 'string';
                    render = function (data, type, row, meta) {
                        return data;
                    };
                }
            }
            return {type: type, render: render}
        }
    }
}
</script>

<style scoped>
.dataTable {
    color: white !important;
    position: relative;
    width: 100%;
    height: auto;
    border-collapse: collapse;
    text-align: center;
}
</style>

<style>
img.datatable-list-image {
    position: relative;
    max-width: 15vw;
    max-height: 10vh;
    margin-right: auto;
    margin-left: auto;
}
</style>
